import { JobCardPdfRecipientType as PdfServiceRecipientType } from '@treadinc/horizon-api-spec';

export type JobCardPdfRecipientType = 'customer' | 'vendor_driver';

export function toPdfServiceRecipientType(
  recipientType: JobCardPdfRecipientType,
): PdfServiceRecipientType {
  return recipientType === 'customer'
    ? PdfServiceRecipientType.CUSTOMER
    : PdfServiceRecipientType.VENDOR_DRIVER;
}
